// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.upload-photo-man{
  background-image: url('Illustration.svg');
  width: 345px;
  height: 387.019px;
  border-radius: 20px;
  fill: #F9F7F3;
  flex-shrink: 0;
  background-repeat: no-repeat;
  background-size: contain;
  margin: 0 auto;
  display: block;
}

.photo-question-text {
  color: #403C3C;
  font-family: "Mecherle Sans";
  text-align: center;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.photo-question-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 283px;

  height:auto;


}
.button-box{
  display: flex;

  justify-content: center;
  align-items: flex-start;
  gap: 16px;
}
#big-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 375px;
  padding: 32px 15px 0px 15px;

  gap: 32px;
}
`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/damage-details/damage-photos/damage-photos.component.css"],"names":[],"mappings":";AACA;EACE,yCAA2D;EAC3D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,4BAA4B;EAC5B,wBAAwB;EACxB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;;EAEZ,WAAW;;;AAGb;AACA;EACE,aAAa;;EAEb,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;;EAE3B,SAAS;AACX","sourcesContent":["\n.upload-photo-man{\n  background-image: url(../../../assets/img/Illustration.svg);\n  width: 345px;\n  height: 387.019px;\n  border-radius: 20px;\n  fill: #F9F7F3;\n  flex-shrink: 0;\n  background-repeat: no-repeat;\n  background-size: contain;\n  margin: 0 auto;\n  display: block;\n}\n\n.photo-question-text {\n  color: #403C3C;\n  font-family: \"Mecherle Sans\";\n  text-align: center;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px;\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.photo-question-box {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 283px;\n\n  height:auto;\n\n\n}\n.button-box{\n  display: flex;\n\n  justify-content: center;\n  align-items: flex-start;\n  gap: 16px;\n}\n#big-box {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-width: 375px;\n  padding: 32px 15px 0px 15px;\n\n  gap: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
